import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';

import { Header } from '@app/navigation/header';
import { Body } from '@ui';
import { ROUTES } from '@constants/routes';
import { scrollToTop } from '@utils/usefulFuncs';
import { AI_TOOLS, DOC_SELECT_MODES } from '@constants';
import ChatQueryTool from '@features/chat/ChatQueryTool';
import { Body5, Container, H5, Page } from '@ui';

const PageWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const tool = AI_TOOLS.CHAT_QUERY;

function ChatDigitalAnalyst() {
  const navigate = useNavigate();

  const [pageError, setPageError] = React.useState(null);
  const [docSelectModes] = React.useState([DOC_SELECT_MODES.allCompany, DOC_SELECT_MODES.myDocs]);
  const [defaultActiveDocSelectMode] = React.useState(DOC_SELECT_MODES.allCompany);

  const onGoBack = () => navigate(ROUTES.home);

  const onPageError = (error) => {
    setPageError(error);
  };

  React.useEffect(() => {
    scrollToTop();
  }, []);

  if (pageError) {
    return (
      <PageWrapper>
        <Header />
        <Body withFooter>
          <Page width={'1000px'}>
            <H5>Digital Analyst Chat</H5>
            <Container top={24} bottom={400}>
              <Body5>Something went wrong, refresh the page and try again.</Body5>
            </Container>
          </Page>
        </Body>
      </PageWrapper>
    );
  }

  return (
    <PageWrapper>
      <Header />
      <Body withFooter>
        <ChatQueryTool
          heading="Digital Analyst Chat"
          onGoBack={onGoBack}
          tool={tool}
          onPageError={onPageError}
          docSelectModes={docSelectModes}
          defaultActiveDocSelectMode={defaultActiveDocSelectMode}
          disableAgent
        />
      </Body>
    </PageWrapper>
  );
}

export default ChatDigitalAnalyst;
